import { render, staticRenderFns } from "./ObserveDetail.vue?vue&type=template&id=0371d9cf&"
import script from "./ObserveDetail.vue?vue&type=script&lang=js&"
export * from "./ObserveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports